import { render } from "./Upgrade.vue?vue&type=template&id=336e20dc"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"
script.render = render

export default script